import React, { useEffect } from 'react';
import { Loading } from '@tencent/ptp-fe-common';
import useAgencyDetail from '../use-agency-detail';
import QualificationInfo from './components/qualification-info';
import { report } from 'store/report';

const Qualification: React.FC = () => {
  const agencyDetailProps = useAgencyDetail();

  useEffect(() => {
    report({ event: 'agency_manage', payload: '资质管理' });
  }, []);

  return (
    <div className="qualification-info">
      <QualificationInfo {...agencyDetailProps} />
      {agencyDetailProps.loading && <Loading />}
    </div>
  );
};

export default Qualification;
